<template>
  <div>
    <h1>Bread Crumb Status</h1>
    <adx-breadcrumb-status :isActive='status' :items="title"/><br>
    <h1>Bread Crumb Progress Status</h1>
    <adx-breadcrumb-progress-status :isActive='status2' :items="title2"/>
  </div>
</template>

<script>
import IndicatorStatus from '@/components/Breadcrumb/IndicatorStatus'
import ProgressStatus from '@/components/Breadcrumb/ProgressStatus'

export default {
  name: 'adx-breadcrumb-docs',
  components: {
    'adx-breadcrumb-status': IndicatorStatus,
    'adx-breadcrumb-progress-status': ProgressStatus,
  },
  data(){
    return {
      title:[
        {
          'status': false,
          'title': 'FIRST',
        },
        {
          'status': false,
          'title': 'SECOND',
        },
        {
          'status': false,
          'title': 'THIRD',
        }
      ],
      title2:[
        {
          'status': false,
          'title': 'First',
        },
        {
          'status': false,
          'title': 'Second',
        },
        {
          'status': false,
          'title': 'Third',
        }
      ],
      status: 'second',
      status2: 'first'
    }
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>